import React from "react";
import { Row, Col } from "reactstrap";
import { toggleYear } from "../../Redux/Actions/activeYear";
import { useSelector, useDispatch } from "react-redux";

const YearButtons = () => {

  const activeYear = useSelector((state) => state.year);
  const dispatch = useDispatch();
  const yearHandler = (value) => {
    dispatch(toggleYear(value));
  };

  return(  
    <Row className="d-flex align items center justify-content-center"> 

      <Col xs={10} 
        className={`
          m-1 responsive-fontsize fw-bold 
          ${ activeYear.year === "year1" 
            ? 'year-button-focused' 
            : 'year-button' 
          }  
        `}
        onClick={() => yearHandler({ ...activeYear, year: "year1" })}    
      >
        <p className="year-text">År 1</p>
      </Col>

      <Col xs={10} 
        className={`
          m-1 responsive-fontsize fw-bold
          ${ activeYear.year === "year2" 
            ? 'year-button-focused' 
            : 'year-button' 
          }  
        `}
        onClick={() => yearHandler({ ...activeYear, year: "year2" })}      
      >
        <p className="year-text">År 2</p>
      </Col>

      <Col xs={10}
        className={`
          m-1 responsive-fontsize fw-bold
          ${ activeYear.year === "year3" 
            ? 'year-button-focused' 
            : 'year-button' 
          }  
        `}
        onClick={() => yearHandler({ ...activeYear, year: "year3" })} 
      >
        <p className="year-text">År 3</p>
      </Col>

    </Row>
  );
}
export default YearButtons;